import { useContext } from "react"
import { DadosFornecedorContext } from "./DadosFornecedorContext"

export function useDadosFornecedorContext() {
    return useContext(DadosFornecedorContext)
}
